/* ut-helpdesk.js — Uni-Trend customer helpdesk, self-contained in the theme (session 2026-09-15b).
 * Talks to Supabase project "Uni-T Customer" with the PUBLISHABLE key only. Every read and write is enforced by RLS:
 * a signed-in customer sees only their own tickets and never an internal note. No-account submit goes through the
 * public RPC helpdesk_submit (validated, honeypot, rate-limited server-side).
 * Sign-in: email link (implicit flow, so it works when the email is opened on another device) OR the 8-digit code.
 * v2 (2026-09-28): signed-in customers attach photos/PDFs (bucket ticket-attachments, 10 MB, images+PDF — the
 * bucket enforces both); first/last name pre-filled from their own contact (rpc helpdesk_me); links in our replies
 * are clickable (a product-links block shows its title as the link).
 * v3 (2026-09-30c): the RFQ form's contact block — phone, organization, job title, street, line 2, country
 * (US/Canada), city, state/province, zip/postal — with the RFQ form's required set, checked here AND in
 * helpdesk_submit (phase5_015). Signed-in customers get their saved block back via helpdesk_me.
 * v4 (2026-09-30c): signed in to the STORE → pre-filled from the account (#uthd-cust, Liquid) and a product picker
 * from their last 20 orders (#uthd-ordered) with "Something else". Email stays editable; if it differs from the
 * account email, a line says where the sign-in link and replies will go (Pete's ruling).
 */
(function () {
  'use strict';
  var root = document.getElementById('ut-helpdesk');
  if (!root || !window.supabase) return;

  var cfg = { url: root.dataset.supabaseUrl, key: root.dataset.supabaseKey };
  var sb = window.supabase.createClient(cfg.url, cfg.key, {
    auth: { flowType: 'implicit', detectSessionInUrl: true, persistSession: true, autoRefreshToken: true }
  });

  var STATUS = {
    new: 'Received', open: 'In progress', pending: 'Awaiting your reply',
    on_hold: 'With our engineering team', solved: 'Resolved', closed: 'Closed'
  };

  // ── tiny DOM helpers (textContent only: customer and staff text is never injected as HTML) ──
  function $(sel) { return root.querySelector(sel); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function show(id) {
    root.querySelectorAll('[data-view]').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== id; });
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  }
  function notice(target, msg, kind) {
    var box = $(target);
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
    box.className = 'ut-hd__notice' + (kind ? ' ut-hd__notice--' + kind : '');
  }
  function busy(btn, on) { if (btn) { btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); } }

  // ── v3: contact block (mirrors UT_REGIONS in ut-info-modal and private.hd_region_ok) ──
  var UT_REGIONS = {
    USA: [['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming']],
    CANADA: [['AB','Alberta'],['BC','British Columbia'],['MB','Manitoba'],['NB','New Brunswick'],['NL','Newfoundland and Labrador'],['NS','Nova Scotia'],['NT','Northwest Territories'],['NU','Nunavut'],['ON','Ontario'],['PE','Prince Edward Island'],['QC','Quebec'],['SK','Saskatchewan'],['YT','Yukon']]
  };
  var REQUIRED = [['first_name', 'first name'], ['last_name', 'last name'], ['email', 'email'], ['street', 'street address'],
                  ['country', 'country'], ['city', 'city'], ['state', 'state / province'], ['zip', 'zip / postal code'],
                  ['subject', 'subject'], ['body', 'description']];
  var PHONE_RE = /^\+?[\d\s().-]{7,20}$/;
  function setRegions(f, keep) {
    var c = f.country.value, list = UT_REGIONS[c] || [], sel = f.state;
    var sl = root.querySelector('[data-slot="state-label"]'), zl = root.querySelector('[data-slot="zip-label"]');
    if (sl) sl.textContent = c === 'CANADA' ? 'Province' : c === 'USA' ? 'State' : 'State / Province';
    if (zl) zl.textContent = c === 'CANADA' ? 'Postal code' : c === 'USA' ? 'Zip code' : 'Zip / Postal code';
    sel.textContent = '';
    var first = document.createElement('option');
    first.value = ''; first.disabled = true; first.selected = true;
    first.textContent = list.length ? 'Select…' : 'Select country first…';
    sel.appendChild(first);
    list.forEach(function (r) { var o = document.createElement('option'); o.value = r[0]; o.textContent = r[1]; sel.appendChild(o); });
    sel.disabled = !list.length;
    if (keep && list.some(function (r) { return r[0] === keep; })) sel.value = keep;
  }
  // ── v4: signed in to the STORE (Liquid renders #uthd-cust / #uthd-ordered only for that customer) ──
  var CUST = document.getElementById('uthd-cust'), CD = CUST ? CUST.dataset : null;
  var STORE_COUNTRY = { US: 'USA', CA: 'CANADA' };
  var picked = { order: '' };                 // the order number the picker filled, so "Something else" can take it back
  function acctHint(f) {
    var h = root.querySelector('[data-slot="acct-email"]');
    if (!h) return;
    var a = CD && CD.email ? CD.email.trim().toLowerCase() : '', v = String(f.email.value || '').trim().toLowerCase();
    var show = !!(a && v && v !== a);
    h.hidden = !show;
    h.textContent = show ? 'We’ll send your sign-in link and our replies to ' + v + ', not your account email ' + a + '.' : '';
  }
  // Each field only if empty; the address only as a whole block, only into an empty one (same rule as helpdesk_me).
  function fillFromStore(f) {
    if (!CD) return;
    [['first_name', 'fname'], ['last_name', 'lname'], ['phone', 'phone'], ['company', 'company']].forEach(function (k) {
      if (CD[k[1]] && !f[k[0]].value) f[k[0]].value = CD[k[1]];
    });
    if (CD.email && !f.email.value && !f.email.readOnly) f.email.value = CD.email;
    var c = STORE_COUNTRY[(CD.country || '').toUpperCase()];
    var addrEmpty = !f.street.value && !f.street2.value && !f.city.value && !f.zip.value && !f.country.value;
    if (c && addrEmpty && CD.street) {
      f.street.value = CD.street; f.street2.value = CD.street2 || ''; f.city.value = CD.city || '';
      f.zip.value = CD.zip || ''; f.country.value = c; setRegions(f, (CD.province || '').toUpperCase());
    }
    acctHint(f);
  }
  function orderedItems() {
    var box = document.getElementById('uthd-ordered');
    if (!box) return [];
    var all = Array.prototype.map.call(box.querySelectorAll('i'), function (i) {
      return { title: i.getAttribute('data-title') || '', sku: i.getAttribute('data-sku') || '', order: i.getAttribute('data-order') || '', date: i.getAttribute('data-date') || '' };
    }).filter(function (x) { return x.title; });
    all.sort(function (a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : 0; });   // newest first
    var seen = {}, out = [];
    all.forEach(function (x) { var k = (x.sku || x.title).toLowerCase(); if (!seen[k]) { seen[k] = 1; out.push(x); } });
    return out;
  }
  function showPickerMode(f, other) {
    var pick = root.querySelector('[data-slot="product-pick"]'), text = root.querySelector('[data-slot="product-text"]');
    if (!pick || pick.hidden) return;
    text.hidden = !other;
  }
  function buildPicker(f) {
    var items = orderedItems(), sel = document.getElementById('uthd-product-pick'), pick = root.querySelector('[data-slot="product-pick"]');
    if (!items.length || !sel || !pick) return;
    sel.textContent = '';
    var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Select a product you ordered…'; ph.disabled = true; ph.selected = true;
    sel.appendChild(ph);
    items.forEach(function (x, n) {
      var o = document.createElement('option'); o.value = String(n);
      o.textContent = x.title + (x.order ? ' · Order ' + x.order : '');
      sel.appendChild(o);
    });
    var other = document.createElement('option'); other.value = '__other__'; other.textContent = 'Something else'; sel.appendChild(other);
    pick.hidden = false; showPickerMode(f, false);
    sel.addEventListener('change', function () {
      if (sel.value === '__other__') {
        f.product.value = '';
        if (picked.order && f.order.value === picked.order) f.order.value = '';
        picked.order = ''; showPickerMode(f, true); f.product.focus(); return;
      }
      var x = items[+sel.value]; if (!x) return;
      f.product.value = x.title.slice(0, 100);
      if (!f.order.value || f.order.value === picked.order) { f.order.value = x.order; picked.order = x.order; }
      showPickerMode(f, false);
    });
  }

  // Returns an error message, or '' when the form may go. Marks bad fields aria-invalid and focuses the first.
  function checkContact(f) {
    var missing = [], bad = null;
    root.querySelectorAll('[data-form="submit"] [aria-invalid]').forEach(function (x) { x.removeAttribute('aria-invalid'); });
    REQUIRED.forEach(function (r) { var x = f[r[0]]; if (x && !String(x.value || '').trim()) { missing.push(r[1]); x.setAttribute('aria-invalid', 'true'); bad = bad || x; } });
    if (missing.length) { bad.focus(); return 'Please fill in: ' + missing.join(', ') + '.'; }
    var zip = f.zip.value.trim().toUpperCase(), phone = f.phone.value.trim();
    if (f.country.value === 'USA' && !/^\d{5}(-\d{4})?$/.test(zip)) { f.zip.setAttribute('aria-invalid', 'true'); f.zip.focus(); return 'Please enter a 5-digit ZIP code.'; }
    if (f.country.value === 'CANADA' && !/^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/.test(zip)) { f.zip.setAttribute('aria-invalid', 'true'); f.zip.focus(); return 'Please enter a postal code like A1A 1A1.'; }
    if (phone && !PHONE_RE.test(phone)) { f.phone.setAttribute('aria-invalid', 'true'); f.phone.focus(); return 'Please enter a valid phone number.'; }
    return '';
  }
  function fmtDate(s) {
    try { return new Date(s).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }); } catch (e) { return s; }
  }
  // ── v2: attachments ──
  var BUCKET = 'ticket-attachments', MAX_BYTES = 10 * 1024 * 1024;
  var EXT_TYPES = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp', heic: 'image/heic', heif: 'image/heif', pdf: 'application/pdf' };
  function fileType(f) {
    var ext = ((f.name || '').split('.').pop() || '').toLowerCase();
    var t = (f.type || '').toLowerCase();
    return (t && Object.keys(EXT_TYPES).some(function (k) { return EXT_TYPES[k] === t; })) ? t : (EXT_TYPES[ext] || '');
  }
  function checkFiles(list) {
    var files = Array.prototype.slice.call(list || []);
    if (files.length > 5) return { error: 'Please attach up to 5 files at a time.' };
    for (var i = 0; i < files.length; i++) {
      if (!fileType(files[i])) return { error: files[i].name + ': only photos (JPG, PNG, WEBP, HEIC) or PDF can be attached.' };
      if (files[i].size > MAX_BYTES) return { error: files[i].name + ' is larger than 10 MB.' };
    }
    return { files: files };
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  }
  function safeName(n) { return (n || 'file').replace(/[^A-Za-z0-9._-]+/g, '_').slice(-80); }
  // Upload each file into <ticket_id>/<uuid>-<name> (the path the storage policy reads), then index it on the ticket.
  function uploadAll(ticketId, contactId, messageId, files) {
    var failed = [];
    return files.reduce(function (p, f) {
      return p.then(function () {
        var type = fileType(f), path = ticketId + '/' + uuid() + '-' + safeName(f.name);
        return sb.storage.from(BUCKET).upload(path, f, { contentType: type, upsert: false }).then(function (up) {
          if (up.error) { failed.push(f.name); return; }
          return sb.from('ticket_attachments').insert({
            ticket_id: ticketId, message_id: messageId, bucket_id: BUCKET, storage_path: path, file_name: f.name,
            mime_type: type, byte_size: f.size, source: 'portal', uploaded_by_contact_id: contactId, stored: true
          }).then(function (r) { if (r.error) failed.push(f.name); });
        });
      });
    }, Promise.resolve()).then(function () { return failed; });
  }
  function openAttachment(a) {
    sb.storage.from(a.bucket_id).createSignedUrl(a.storage_path, 300).then(function (r) {
      if (r.data && r.data.signedUrl) window.open(r.data.signedUrl, '_blank', 'noopener');
      else notice('[data-notice="thread"]', 'That file could not be opened. Please try again.', 'error');
    });
  }
  // ── v2: links in our replies are clickable. "- Datasheet: Title" + an indented URL line -> "Datasheet: <a>Title</a>".
  var URL_RE = /(https?:\/\/[^\s<>"'()\[\]]+)/g;
  function linkEl(href, text) {
    var a = el('a', { href: href, target: '_blank', rel: 'noopener', text: text });
    return a;
  }
  function renderBody(text) {
    var box = el('div', { class: 'ut-hd__msg-body' });
    var lines = String(text || '').split('\n');
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i], nxt = lines[i + 1];
      var m = /^(- [^:]{1,40}: )(.+)$/.exec(ln), u = nxt && /^[ \t]+(https?:\/\/[^\s]+)\s*$/.exec(nxt);
      if (m && u) { box.appendChild(document.createTextNode(m[1])); box.appendChild(linkEl(u[1], m[2])); i++; }
      else {
        var last = 0, mm; URL_RE.lastIndex = 0;
        while ((mm = URL_RE.exec(ln))) {
          var href = mm[1].replace(/[.,;:!?]+$/, '');
          box.appendChild(document.createTextNode(ln.slice(last, mm.index)));
          box.appendChild(linkEl(href, href));
          last = mm.index + href.length;
        }
        box.appendChild(document.createTextNode(ln.slice(last)));
      }
      if (i < lines.length - 1) box.appendChild(document.createTextNode('\n'));
    }
    return box;
  }

  // Keep the theme-preview parameter so the link returns to the draft theme while testing.
  function returnUrl() {
    var u = new URL(window.location.href);
    var keep = new URL(u.origin + u.pathname);
    if (u.searchParams.get('preview_theme_id')) keep.searchParams.set('preview_theme_id', u.searchParams.get('preview_theme_id'));
    return keep.toString();
  }

  var state = { email: null, ticketId: null, contactId: null };

  // ── send link / code ──
  function sendLink(email) {
    return sb.auth.signInWithOtp({ email: email, options: { emailRedirectTo: returnUrl(), shouldCreateUser: true } });
  }

  (function () {
    var f = $('[data-form="submit"]');
    f.country.addEventListener('change', function () { setRegions(f); f.country.removeAttribute('aria-invalid'); });
    f.addEventListener('input', function (e) { if (e.target && e.target.removeAttribute) e.target.removeAttribute('aria-invalid'); });
    // after a reset the country is blank, unless the saved-block pre-fill already ran and set it: leave that alone
    f.addEventListener('reset', function () { setTimeout(function () { if (!f.country.value) setRegions(f); }, 0); });
    // v4: store account
    f.addEventListener('reset', function () { picked.order = ''; showPickerMode(f, false); setTimeout(function () { acctHint(f); }, 0); });
    f.email.addEventListener('input', function () { acctHint(f); });
    buildPicker(f);
    fillFromStore(f);
  })();

  // ── submit (works signed out and signed in) ──
  $('[data-form="submit"]').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, btn = f.querySelector('button[type="submit"]');
    notice('[data-notice="submit"]', '');
    busy(btn, true);
    var email = (f.email.value || '').trim();
    var chk = checkFiles(f.files && f.files.files);
    if (chk.error) { notice('[data-notice="submit"]', chk.error, 'error'); busy(btn, false); return; }
    var bad = checkContact(f);
    if (bad) { notice('[data-notice="submit"]', bad, 'error'); busy(btn, false); return; }
    sb.rpc('helpdesk_submit', {
      p_email: email, p_subject: f.subject.value, p_body: f.body.value,
      p_product_sku: f.product.value, p_order_number: f.order.value,
      p_first_name: f.first_name.value, p_last_name: f.last_name.value, p_website: f.website.value,
      p_company: f.company.value, p_phone: f.phone.value, p_job_title: f.job_title.value,
      p_street: f.street.value, p_street2: f.street2.value, p_city: f.city.value,
      p_state: f.state.value, p_zip: f.zip.value, p_country: f.country.value
    }).then(function (res) {
      if (res.error) throw new Error('We could not submit your request. Please try again.');
      var d = res.data || {};
      if (!d.ok) { notice('[data-notice="submit"]', d.message || 'Please check the form and try again.', 'error'); return null; }
      return sb.auth.getSession().then(function (s) {
        if (s.data && s.data.session) {           // already signed in: attach any files, then the list
          var files = chk.files || [];
          var attach = !files.length ? Promise.resolve([]) :
            sb.from('tickets').select('id, contact_id').eq('ticket_number', d.ticket_number).single().then(function (t) {
              if (t.error || !t.data) return files.map(function (x) { return x.name; });
              return sb.from('messages').select('id').eq('ticket_id', t.data.id).order('sent_at', { ascending: true }).limit(1)
                .then(function (m) {
                  var mid = (m.data && m.data[0] && m.data[0].id) || null;
                  return uploadAll(t.data.id, t.data.contact_id, mid, files);
                });
            });
          return attach.then(function (failed) {
            f.reset(); lockEmail(s.data.session.user.email); fillFromStore(f); fillName();
            return loadTickets().then(function () {
              notice('[data-notice="list"]', 'Request #' + d.ticket_number + ' received.' +
                (failed.length ? ' These files could not be attached: ' + failed.join(', ') + '.' : ''), failed.length ? 'error' : 'ok');
            });
          });
        }
        state.email = email;
        return sendLink(email).then(function (r) {
          f.reset();
          $('[data-slot="ticket-number"]').textContent = d.ticket_number ? '#' + d.ticket_number : '';
          $('[data-slot="sent-to"]').textContent = email;
          notice('[data-notice="code"]', r.error ? 'Your request was received, but we could not send the email just now. Use "Send a new link" below.' : '', r.error ? 'error' : '');
          show('sent');
        });
      });
    }).catch(function (err) {
      notice('[data-notice="submit"]', err.message, 'error');
    }).then(function () { busy(btn, false); });
  });

  // ── sign in without a new request ──
  $('[data-form="signin"]').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, btn = f.querySelector('button[type="submit"]'), email = (f.email.value || '').trim();
    notice('[data-notice="signin"]', '');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { notice('[data-notice="signin"]', 'Please enter a valid email address.', 'error'); return; }
    busy(btn, true);
    state.email = email;
    sendLink(email).then(function (r) {
      if (r.error) { notice('[data-notice="signin"]', 'We could not send the email just now. Please wait a minute and try again.', 'error'); return; }
      $('[data-slot="ticket-number"]').textContent = '';
      $('[data-slot="sent-to"]').textContent = email;
      show('sent');
    }).then(function () { busy(btn, false); });
  });

  // ── 8-digit code (cross-device) ──
  $('[data-form="code"]').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, btn = f.querySelector('button[type="submit"]'), token = (f.code.value || '').replace(/\D/g, '');
    notice('[data-notice="code"]', '');
    if (!state.email || token.length < 6) { notice('[data-notice="code"]', 'Enter the code from the email.', 'error'); return; }
    busy(btn, true);
    sb.auth.verifyOtp({ email: state.email, token: token, type: 'email' }).then(function (r) {
      if (r.error) notice('[data-notice="code"]', 'That code is not valid or has expired. Send a new link and try again.', 'error');
    }).then(function () { busy(btn, false); });
  });

  $('[data-action="resend"]').addEventListener('click', function (e) {
    if (!state.email) { show('start'); return; }
    busy(e.target, true);
    sendLink(state.email).then(function (r) {
      notice('[data-notice="code"]', r.error ? 'Please wait a minute before requesting another email.' : 'A new email is on its way.', r.error ? 'error' : 'ok');
    }).then(function () { busy(e.target, false); });
  });

  // ── signed-in views ──
  function lockEmail(email) {
    var input = $('[data-form="submit"] input[name="email"]');
    input.value = email; input.readOnly = true;
    acctHint($('[data-form="submit"]'));   // v4: the support sign-in email may differ from the store account's
  }
  // v2: the customer typed their name on the first request; fill it back in (never over what they typed now).
  function fillName() {
    return sb.rpc('helpdesk_me').then(function (r) {
      var me = r.data && (Array.isArray(r.data) ? r.data[0] : r.data);
      if (!me) return;
      var f = $('[data-form="submit"]');
      if (me.first_name && !f.first_name.value) f.first_name.value = me.first_name;
      if (me.last_name && !f.last_name.value) f.last_name.value = me.last_name;
      // v3: the rest of their saved block, each only into an empty field; the address only as a whole
      [['company', 'company'], ['phone', 'phone'], ['job_title', 'job_title']].forEach(function (k) {
        if (me[k[1]] && !f[k[0]].value) f[k[0]].value = me[k[1]];
      });
      var addrEmpty = !f.street.value && !f.street2.value && !f.city.value && !f.zip.value && !f.country.value;
      if (addrEmpty && me.country && UT_REGIONS[me.country]) {
        f.street.value = me.street || ''; f.street2.value = me.street2 || ''; f.city.value = me.city || '';
        f.zip.value = me.zip_postal || ''; f.country.value = me.country; setRegions(f, me.state_province);
      }
    });
  }

  function loadTickets() {
    notice('[data-notice="list"]', '');
    var list = $('[data-slot="tickets"]');
    list.textContent = 'Loading…';
    show('list');
    return sb.from('tickets')
      .select('id, ticket_number, subject, status, product_sku, created_at, last_activity_at, contact_id')
      .order('last_activity_at', { ascending: false })
      .then(function (r) {
        list.textContent = '';
        if (r.error) { notice('[data-notice="list"]', 'We could not load your requests. Please refresh the page.', 'error'); return; }
        if (!r.data.length) {
          list.appendChild(el('p', { class: 'ut-hd__empty', text: 'No support requests yet for this email address.' }));
          return;
        }
        r.data.forEach(function (t) {
          list.appendChild(el('button', { type: 'button', class: 'ut-hd__ticket', onclick: function () { openTicket(t); } }, [
            el('span', { class: 'ut-hd__ticket-top' }, [
              el('span', { class: 'ut-hd__ticket-no', text: '#' + t.ticket_number }),
              el('span', { class: 'ut-hd__status ut-hd__status--' + t.status, text: STATUS[t.status] || t.status })
            ]),
            el('span', { class: 'ut-hd__ticket-subject', text: t.subject }),
            el('span', { class: 'ut-hd__ticket-meta', text: (t.product_sku ? t.product_sku + ' · ' : '') + 'Updated ' + fmtDate(t.last_activity_at) })
          ]));
        });
      });
  }

  function openTicket(t) {
    state.ticketId = t.id; state.contactId = t.contact_id;
    $('[data-slot="t-title"]').textContent = '#' + t.ticket_number + ' — ' + t.subject;
    $('[data-slot="t-status"]').textContent = STATUS[t.status] || t.status;
    $('[data-slot="t-status"]').className = 'ut-hd__status ut-hd__status--' + t.status;
    notice('[data-notice="thread"]', '');
    show('thread');
    return loadThread();
  }

  function loadThread() {
    var box = $('[data-slot="messages"]');
    box.textContent = 'Loading…';
    return Promise.all([
      sb.from('messages').select('id, author_type, body, sent_at').eq('ticket_id', state.ticketId).order('sent_at', { ascending: true }),
      sb.from('ticket_attachments').select('id, message_id, bucket_id, storage_path, file_name, stored')
        .eq('ticket_id', state.ticketId).eq('bucket_id', BUCKET).eq('stored', true).order('created_at', { ascending: true })
    ]).then(function (res) {
        var r = res[0], atts = (res[1] && res[1].data) || [];
        box.textContent = '';
        if (r.error) { notice('[data-notice="thread"]', 'We could not load this conversation. Please refresh the page.', 'error'); return; }
        r.data.forEach(function (m) {
          var mine = m.author_type === 'customer';
          var mine_atts = atts.filter(function (a) { return a.message_id === m.id; });
          box.appendChild(el('div', { class: 'ut-hd__msg ' + (mine ? 'ut-hd__msg--mine' : 'ut-hd__msg--staff') }, [
            el('div', { class: 'ut-hd__msg-head', text: (mine ? 'You' : 'Uni-Trend Support') + ' · ' + fmtDate(m.sent_at) }),
            renderBody(m.body),
            mine_atts.length ? el('div', { class: 'ut-hd__files' }, mine_atts.map(function (a) {
              return el('button', { type: 'button', class: 'ut-hd__file', text: '📎 ' + a.file_name, onclick: function () { openAttachment(a); } });
            })) : null
          ]));
        });
      });
  }

  $('[data-form="reply"]').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, btn = f.querySelector('button[type="submit"]'), body = (f.body.value || '').trim();
    notice('[data-notice="thread"]', '');
    var chk = checkFiles(f.files && f.files.files);
    if (chk.error) { notice('[data-notice="thread"]', chk.error, 'error'); return; }
    var files = chk.files || [];
    if (!body && !files.length) return;
    if (!body) body = 'Attached: ' + files.map(function (x) { return x.name; }).join(', ');
    if (body.length > 10000) { notice('[data-notice="thread"]', 'Replies are limited to 10,000 characters.', 'error'); return; }
    busy(btn, true);
    sb.from('messages').insert({
      contact_id: state.contactId, ticket_id: state.ticketId,
      direction: 'inbound', author_type: 'customer', body: body, source: 'portal'
    }).select('id').single().then(function (r) {
      if (r.error) { notice('[data-notice="thread"]', 'Your reply could not be sent. Please try again.', 'error'); return; }
      return uploadAll(state.ticketId, state.contactId, r.data && r.data.id, files).then(function (failed) {
        f.reset();
        return loadThread().then(function () {
          if (failed.length) notice('[data-notice="thread"]', 'Your reply was sent, but these files could not be attached: ' + failed.join(', ') + '.', 'error');
        });
      });
    }).then(function () { busy(btn, false); });
  });

  root.querySelectorAll('[data-action="back"]').forEach(function (b) { b.addEventListener('click', loadTickets); });
  root.querySelectorAll('[data-action="new"]').forEach(function (b) {
    b.addEventListener('click', function () { notice('[data-notice="submit"]', ''); show('start'); });
  });
  root.querySelectorAll('[data-action="signout"]').forEach(function (b) {
    b.addEventListener('click', function () {
      sb.auth.signOut().then(function () {
        var input = $('[data-form="submit"] input[name="email"]');
        input.readOnly = false; input.value = '';
        var sf = $('[data-form="submit"]'); sf.reset(); fillFromStore(sf);
        root.classList.remove('is-signed-in');
        show('start');
      });
    });
  });

  // ── boot ──
  function onSession(session) {
    if (session) {
      root.classList.add('is-signed-in');
      $('[data-slot="who"]').textContent = session.user.email;
      lockEmail(session.user.email);
      fillName();
      if (window.location.hash && /access_token|error/.test(window.location.hash)) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      loadTickets();
    } else {
      root.classList.remove('is-signed-in');
      show('start');
      if (linkError) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        notice('[data-notice="signin"]', 'That sign-in link has expired or was already used. Enter your email to get a new one.', 'error');
      }
    }
  }

  var linkError = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('error_description');

  // INITIAL_SESSION fires once on load (after any link in the URL has been processed); SIGNED_IN fires after a code.
  var signedInShown = false;
  // Supabase calls made INSIDE this callback can deadlock the auth lock, so defer onSession to the next tick.
  sb.auth.onAuthStateChange(function (event, session) {
    if (event === 'INITIAL_SESSION') { signedInShown = !!session; setTimeout(function () { onSession(session); }, 0); }
    else if (event === 'SIGNED_IN' && !signedInShown) { signedInShown = true; setTimeout(function () { onSession(session); }, 0); }
    else if (event === 'SIGNED_OUT') { signedInShown = false; }
  });
})();